import React, {useContext, useEffect} from "react";
import {Link} from 'react-router-dom'

import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import {Loading} from '../../custom/LoadingComponent';
import ResourceNotAvailable from '../../custom/ResourceNotAvailable';
import EmployeeTabsRenderer from './EmployeeTabsRendererComponent';
import BucketContext from "../../context/BucketContext";
import * as ReduxDataStatus from '../../../utils/constants/ReduxDataStatus';


const EmployeeManagement = (props) => {
    console.log('___EmployeeManagement Component___');
    const bucketContext = useContext(BucketContext);

    useEffect(() => {

        props.loadComponentData();
        if(bucketContext.bucket.mostRecentEmployeeId != null) {
            console.log('Reseting the mostRecentEmployeeId: ' + JSON.stringify(bucketContext.bucket.mostRecentEmployeeId));
            bucketContext.setBucketValue({mostRecentEmployeeId: null});
        }
    });

    if(props.dataStatus === ReduxDataStatus.LOADING) {
        return(
            <Container maxWidth="xl" >
                <Box px={{ xs: 3, sm: 7 }}>
                    <Loading />
                </Box>
            </Container>
        );
    }
    else if(props.employee == null) {
        return(
            <ResourceNotAvailable />
        );    
    }
    else if(props.employee != null) {

        const employerName = props.employers
            .filter((employer) => employer.id === props.employee.employmentDetails.employerId)
            .map((employer) => employer.generalSection.employerName);

        return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>

                <Stack spacing={1} sx={{marginBottom: 2}}>
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                            <Link to='/employees'>Angajati</Link>
                            <Typography color="text.primary">{props.employee.generalSection.lastName} {props.employee.generalSection.firstName}</Typography>
                        </Breadcrumbs>
                    </Box>

                    <Box>
                        <h3>{props.employee.generalSection.lastName} {props.employee.generalSection.firstName} - {employerName}</h3>
                    </Box>
                    <hr/>

                    <EmployeeTabsRenderer 
                        employee={props.employee} 
                        patchEmployee={props.patchEmployee} 
                        employers={props.employers}
                        authorizations={props.authorizations}
                        authorizationsDataStatus={props.authorizationsDataStatus}
                        corCodes={props.corCodes}
                    />
                </Stack>

            </Box>
            </Container>
        );
    } 

}


export default EmployeeManagement